/** O documento tem quatro folhas, como o do sistema anterior. */
export const TOTAL_DE_PAGINAS = 4

interface Props {
  /** Número do chamado no e-Niterói, já com o texto de vazio resolvido. */
  chamado: string
  /** Código estável do documento (ver `codigoDoDocumento`). */
  codigo: string
  /** Instante da emissão, já formatado. */
  emitidoEm: string
  /** Qual das quatro folhas é esta. */
  pagina: number
}

/**
 * O rodapé, repetido nas quatro folhas.
 *
 * Ele é escrito uma vez por folha, e não fixado na janela. O documento antigo usava
 * `position: fixed` com `counter(page)`, que é o que o dompdf entende; navegador não
 * repete elemento fixo em toda página impressa de forma confiável, e o resultado seria um
 * rodapé só na primeira folha. Como as quebras de página são nossas, sabemos em que folha
 * estamos e escrevemos o número — o mesmo texto, sem depender do motor de impressão.
 *
 * "Página N de 4" conta SEÇÃO, não folha física. Se alguém escrever um plano de rollback de
 * três páginas, o navegador acrescenta papel e a numeração fica curta — exatamente como no
 * documento antigo, onde o "de 4" também era fixo no template.
 *
 * @param props chamado, código do documento, instante da emissão e o número da folha
 * @returns o rodapé de uma folha
 */
export function RodapeDoRelatorio({ chamado, codigo, emitidoEm, pagina }: Props) {
  return (
    <footer className="rdm-rodape">
      <span>
        Chamado: {chamado} - Código do Documento: {codigo} - Data da Emissão: {emitidoEm}
      </span>
      <span className="rdm-rodape-pagina">
        Página {pagina} de {TOTAL_DE_PAGINAS}
      </span>
    </footer>
  )
}
